import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { Done, Description } from '@material-ui/icons';
import useError from 'components/ErrorProvider/useError';
import { getAgreementFile } from 'api';
import { downloadFile } from 'helper';
import { IUserAgreementDialogProps } from './interfaces';

const UserAgreementDialog: React.FC<IUserAgreementDialogProps> = ({ open, onAccept }) => {
  const [loading, setLoading] = useState(false);
  const [downloadingFile, setDownloadingFile] = useState(false);
  const { addError } = useError();

  const handleAccept = async (): Promise<void> => {
    try {
      setLoading(true);
      await onAccept();
    } catch (error) {
      addError('Ошибка при принятии соглашения');
      setLoading(false);
    }
  };

  const handleDownloadAgreement = async (): Promise<void> => {
    try {
      setDownloadingFile(true);
      const blob = await getAgreementFile();
      downloadFile(blob, 'application/pdf', 'user_agreement.pdf');
    } catch (error) {
      addError('Ошибка при загрузке файла соглашения');
    } finally {
      setDownloadingFile(false);
    }
  };

  const handleClose = (_event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth scroll="body">
      <DialogTitle>
        <b>Согласие на обработку персональных данных</b>
      </DialogTitle>

      <DialogContent dividers>
        <DialogContentText>
          Я предоставляю согласие на обработку персональных данных, а так же подтверждаю ознакомление и согласие с
          Политикой конфиденциальности и Пользовательским соглашением.
        </DialogContentText>

        <Box sx={{ mb: 1 }}>
          <Button
            color="primary"
            variant="outlined"
            fullWidth
            startIcon={<Description />}
            onClick={handleDownloadAgreement}
            disabled={downloadingFile}
          >
            {downloadingFile ? 'Загрузка...' : 'Скачать пользовательское соглашение'}
          </Button>
        </Box>

        <DialogContentText gutterBottom={false}>Примите соглашения, что бы войти.</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button color="primary" variant="contained" disabled={loading} onClick={handleAccept} startIcon={<Done />}>
          {loading ? 'Обработка...' : 'Принимаю'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserAgreementDialog;
